exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ng-select {\n  background-color: #fff;\n}\n:host >>> .select2-container--default {\n  width: auto !important;\n}\n.ic-box__row {\n  display: -ms-flexbox;\n  display: flex;\n}\n.ic-box__name {\n  font-size: 14px;\n  color: #526069;\n  font-weight: 500;\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n}\n.ic-box__data-status {\n  font-size: 12px;\n  padding-top: 1px;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n}\n.ic-box__phone {\n  font-size: 12px;\n  color: #76838f;\n  margin-top: 4px;\n  font-weight: 400;\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n}\n.box_info strong {\n  margin-bottom: 10px;\n}\n.box_info span {\n  margin-bottom: 10px;\n}\n.search_detail {\n  margin-left: -15px;\n}\n\n.img-list {\n  margin-bottom: 10px;\n}\n.img-list a {\n  text-decoration: none;\n}\n.img-list img {\n  width: 80px;\n  height: 80px;\n  border-radius: 5px;\n  border: 1px solid #e5e5e5;\n  margin-right: 5px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/qrcode/requestBoxSend/requestBoxSend.component.css
// module id = ../../../../../src/app/pages/admin/qrcode/requestBoxSend/requestBoxSend.component.css
// module chunks = 3